import { STAGING_IP } from "../../.env";
const protocol = 'http';
const host = STAGING_IP;
const port = '';
const trailUrl = 'api/v1/';

const hostUrl = `${host}/`;
const endpoint = `${protocol}://${host}${(port ? ':' + port : '')}/${trailUrl}`;

export default {
    host: host,
    apiUrl: trailUrl,
    endpoint: endpoint,
    hostUrl: hostUrl
};
